import { render, staticRenderFns } from "./NingboTelecomJd.vue?vue&type=template&id=235ba7a3&scoped=true"
import script from "./NingboTelecomJd.vue?vue&type=script&lang=js"
export * from "./NingboTelecomJd.vue?vue&type=script&lang=js"
import style0 from "./NingboTelecomJd.vue?vue&type=style&index=0&id=235ba7a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235ba7a3",
  null
  
)

export default component.exports